// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TypesServerStatus
 */
export interface TypesServerStatus {
  /**
   *
   * @type {string}
   * @memberof TypesServerStatus
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof TypesServerStatus
   */
  health?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof TypesServerStatus
   */
  hosting?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof TypesServerStatus
   */
  modeConstraint?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof TypesServerStatus
   */
  requestedHosting?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof TypesServerStatus
   */
  serverId?: string;
  /**
   *
   * @type {string}
   * @memberof TypesServerStatus
   */
  state?: string;
}

/**
 * Check if a given object implements the TypesServerStatus interface.
 */
export function instanceOfTypesServerStatus(
  value: object,
): value is TypesServerStatus {
  return true;
}

export function TypesServerStatusFromJSON(json: any): TypesServerStatus {
  return TypesServerStatusFromJSONTyped(json, false);
}

export function TypesServerStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesServerStatus {
  if (json == null) {
    return json;
  }
  return {
    address: json['Address'] == null ? undefined : json['Address'],
    health: json['Health'] == null ? undefined : json['Health'],
    hosting: json['Hosting'] == null ? undefined : json['Hosting'],
    modeConstraint:
      json['ModeConstraint'] == null ? undefined : json['ModeConstraint'],
    requestedHosting:
      json['RequestedHosting'] == null ? undefined : json['RequestedHosting'],
    serverId: json['ServerId'] == null ? undefined : json['ServerId'],
    state: json['State'] == null ? undefined : json['State'],
  };
}

export function TypesServerStatusToJSON(json: any): TypesServerStatus {
  return TypesServerStatusToJSONTyped(json, false);
}

export function TypesServerStatusToJSONTyped(
  value?: TypesServerStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    Address: value['address'],
    Health: value['health'],
    Hosting: value['hosting'],
    ModeConstraint: value['modeConstraint'],
    RequestedHosting: value['requestedHosting'],
    ServerId: value['serverId'],
    State: value['state'],
  };
}
